/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

function SEO({ description, lang, meta, title, keywords, canonical }) {
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={`${title}`}
      // titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      link={[
      {
         rel: "canonical",
         href: canonical,
        },
       {
          rel: "alternate",
          hrefLang: "x-default",
          href: "https://www.airasia.com/aa/driver-rider/",
        },
        {
          rel: "alternate",
          hrefLang: "en",
          href: "https://www.airasia.com/aa/driver-rider/",
        },
        // {
        //   rel: "alternate",
        //   hrefLang: "en-TH",
        //   href: "https://www.airasia.com/aa/driver-rider/th",
        // },
        {
          rel: "alternate",
          hrefLang: "th-TH",
          href: "https://www.airasia.com/aa/driver-rider/th/th",
        },
        // {
        //   rel: "alternate",
        //   hrefLang: "en-SG",
        //   href: "https://www.airasia.com/aa/driver-rider/sg",
        // },
        {
          rel: "alternate",
          hrefLang: "ms-MY",
          href: "https://www.airasia.com/aa/driver-rider/ms",
        },
      ]}
      meta={[
        {
          name: `description`,
          content: description,
        },
        {
          name: `keywords`,
          content: keywords,
        },
        {
          name: `robots`,
          content:
            process.env.GATSBY_ENV === "stg"
              ? "nofollow, noindex"
              : "follow, index",
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:url`,
          content: "https://www.airasia.com/aa/driver-rider/",
        },
        {
          property: `og:image`,
          content:
            "https://a.staticaa.com/images/misc/aa-superapps.jpg",
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:locale`,
          content: `en-GB`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:image`,
          content:
            "https://a.staticaa.com/images/misc/aa-superapps.jpg",
        },
        {
          name: `twitter:site`,
          content: "@airasia.com",
        },
        {
          name: `twitter:description`,
          content: description,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  keywords: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  hrefLang: PropTypes.string,
  keywords: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  canonical: PropTypes.string,
}

export default SEO
